export class ForwarderSettingExportData {

  seqNo: number | null;
  facility: string | null;
  deliveryCountry: string | null;
  deliveryCountryChinese: string | null;
  deliveryCity: string | null;
  deliveryCityChinese: string | null;
  weightLowerLimit: number | null;
  weightUpperLimit: number | null;
  forwarderCode: string | null;
  direct: string | null;
  createDt: Date | null;
  createUser: string | null;
  updateDt: Date | null;
  updateUser: string | null;
  incoTerm: any[] | null;
  rfqCountry: string | null;
  rfqCity: string | null;
  citySeqNo: number | null;
  deliveryCountryShorthand: string | null;
  rfqIncoTerm: string | null;

  constructor() {
    this.seqNo = null;
    this.facility = null;
    this.deliveryCountry = null;
    this.deliveryCountryChinese = null;
    this.deliveryCity = null;
    this.deliveryCityChinese = null;
    this.weightLowerLimit = null;
    this.weightUpperLimit = null;
    this.forwarderCode = null;
    this.direct = null;
    this.createDt = null;
    this.createUser = null;
    this.updateDt = null;
    this.updateUser = null;
    this.incoTerm = null;
    this.rfqCountry = null;
    this.rfqCity = null;
    this.citySeqNo = null;
    this.deliveryCountryShorthand = null;
    this.rfqIncoTerm = null;
  }
}
